import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular/lazy';
import { from, map, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private navCtrl: NavController,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {

    const loggedIn = this.authService.isLoggedIn();
    if (!loggedIn) {
      this.navCtrl.navigateRoot(['/login']);
      return of(false);
    }
    // Safety net for every entry path (restored session, deep link, etc.):
    // the app is customer-only.
    if (this.authService.hasNonCustomerRole()) {
      return from(this.authService.rejectNonCustomerRole()).pipe(
        map(() => {
          this.navCtrl.navigateRoot(['/login']);
          return false;
        })
      );
    }
    return of(true);
  }
}
